<template>
  <Pie id="my-chart-pie" :options="chartOptions" :data="chartData" />
</template>

<script>
import { Pie } from "vue-chartjs";
import { pieLabels } from "./pieLabels";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
  pieLabels
);

export default {
  name: "BarChart1",
  components: {
    Pie,
  },
  props: {
    chartId: {
      type: String,
      default: "pie-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      chartData: {
        labels: [
          "Serviços Digitais\n26,28%",
          "Shows e Eventos\n19,78%",
          "Usuários Gerais\n19,12%",
          "Televisão Aberta\n14,65%",
          "Televisão por Assinatura\n10,36%",
          "Rádio\n7,90%",
          "Cinema 1,90%",
        ],
        datasets: [
          {
            backgroundColor: [
              "rgba(139,197,63, 1)",
              "rgba(139,197,63, 0.85)",
              "rgba(139,197,63, 0.65)",
              "rgba(139,197,63, 0.45)",
              "rgba(139,197,63, 0.25)",
              "rgba(139,197,63, 0.15)",
              "rgba(139,197,63, 0.1)",
            ],
            hoverBackgroundColor: [
              "rgba(122,171,57, 0.9)",
              "rgba(122,171,57, 0.8)",
              "rgba(122,171,57, 0.7)",
              "rgba(122,171,57, 0.6)",
              "rgba(122,171,57, 0.5)",
              "rgba(122,171,57, 1)",
              "rgba(122,171,57, 1)",
            ],
            data: [26.28, 19.78, 19.12, 14.65, 10.36, 7.90, 1.90],
            borderWidth: 0,
          },
        ],
      },
      chartOptions: {
        plugins: {
          tooltip: {
            enabled: false,
          },
          scale: {
            delay: 1000,
          },
          legend: {
            display: false,
          },
          datalabels: {
            display: false,
          },
        },
        animation: {
          animateScale: true,
        },
        layout: {
          padding: {
            top: 60,
            bottom: 60,
          },
        },
        responsive: true,
        aspectRatio: 1.8,
        // maintainAspectRatio: false,
        cutout: "70%",
        hoverOffset: 5,
      },
      plugins: [pieLabels],
    };
  },
};
</script>
